<router-outlet></router-outlet>
@if (!production) {
  <nom-error-reporter></nom-error-reporter>
}
